import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCapButt = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 5.2V4h8v10H6.9v-1.2C4.8 12.8 3 11.1 3 9c0-2.1 1.8-3.8 4-3.8zm7 4.8V8H9c-.3-.8-1.2-1.3-2-1.3-1.3 0-2.4 1-2.4 2.3 0 1.3 1.1 2.3 2.4 2.3.8 0 1.5-.5 2-1.3h5z"
	})
});
export default SvgCapButt;
